module.exports = __webpack_public_path__ + "img/group-of-people.668e622f.jpg";